export const defaultBaseOrderingModuleConfig = {
  orderingOrderUntilClosed: true,
  orderingAllowScheduledOrders: "always" as const,
  orderingShouldTotal: false,
  orderingExactTimeEstimate: true,
  useOrderEntryTool: true,
};
const defaultPaymentModuleConfig = {
  provider: "none" as const,
};
export const defaultPickupModuleConfig = {
  pickupEnabled: false,
  pickupPaymentModuleConfig: defaultPaymentModuleConfig,
};
export const defaultDeliveryModuleConfig = {
  deliveryEnabled: false,
  deliveryPaymentModuleConfig: defaultPaymentModuleConfig,
  deliveryVerifyAddress: true,
  deliveryLatitude: 0,
  deliveryLongitude: 0,
  deliveryFee: 0,
  deliveryFeeConfigType: "FLAT" as const,
  deliveryFeeConfigTiers: [{ minMiles: 0, amount: 0 }],
  deliveryRadius: 0,
  deliveryRegionCode: "US",
  firstDeliveryEnabled: false,
};
